import { memo } from 'react';

export default memo(() => {
    return (
        <div className={'animate-pulse space-y-1.5'}>
            <div className={'aspect-product w-full bg-neutral-200'} />
            <div className={'flex flex-col gap-y-1.5'}>
                <div className={'h-4 w-36 rounded-4 bg-neutral-300'} />
                <div className={'h-4 w-24 rounded-4 bg-neutral-300'} />
            </div>
            <div className={'h-4 w-20 rounded-4 bg-neutral-400'} />
        </div>
    );
});
